import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  response: null,
  distributionList: [],
  listCount: 0,
  listadded: false,
  listUpdated: false,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getAllDistributionList = createAsyncThunk(
  'dashboard/distributionList/?page=1&limit=5',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      //const response = await axios.get('/api/dashboard/distributionList/?page=1&limit=2',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let response = await axios({
        url: `/api/dashboard/distributionList/?page=${udata}&limit=5`,
        method: 'get',
        //timeout: 8000,
        headers: {
          //'Content-Type': 'application/json',
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const AddDistributionList = createAsyncThunk(
  'dashboard/distributionList/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.post('/api/dashboard/distributionList/', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const updateDistributionList = createAsyncThunk(
  'update/distributionList/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/dashboard/distributionList/', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);





export const distributionListSlice = createSlice({
  name: 'addDistributionList',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateDistributionList: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.listadded = false;
      state.listUpdated = false;
    },
    isSuccess: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.listadded = false;
      state.listUpdated = false;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {

    [getAllDistributionList.fulfilled]: (state, { payload }) => {

      state.distributionList = payload.data != "" ? payload.data.distributionList : null;
      state.listCount = payload.data != "" ? payload.data.count : 0;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getAllDistributionList.pending]: (state) => {
      state.isFetching = true;
    },
    [getAllDistributionList.rejected]: (state, { payload }) => {

      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },

    [AddDistributionList.fulfilled]: (state, { payload }) => {

      if (payload.success == false) state.isError = true;
      else state.isError = false;
      if (payload.success) state.listadded = true;
      if (payload.message) state.errorMessage = payload.message;
      else state.errorMessage = '';
      return state;
    },
    [AddDistributionList.pending]: (state) => {
      state.isFetching = true;
    },
    [AddDistributionList.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },

    [updateDistributionList.fulfilled]: (state, { payload }) => {

      if (payload.success == false) state.isError = true;
      else state.isError = false;
      if (payload.success) state.listUpdated = true;
      if (payload.message) state.errorMessage = payload.message;
      else state.errorMessage = '';

      return state;
    },
    [updateDistributionList.pending]: (state) => {
      state.isFetching = true;
    },
    [updateDistributionList.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }


  },
});


export const deleteDistributionList = createAsyncThunk(
  '/dashboard/distributionList/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      //const response = await axios.get('/api/dashboard/distributionList/',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let response = await axios({
        url: `/api/dashboard/distributionList/${udata}`,
        method: 'delete',
        //timeout: 8000,
        headers: {
          //'Content-Type': 'application/json',
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);



export const { clearStateDistributionList, isSuccess } = distributionListSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateDistributionList());
  }
}

export function clearStateSuccess() {

  return async (dispatch) => {
    dispatch(isSuccess());
  }
}

export const DistributionListSelector = (state) => state.distributionList;

export default distributionListSlice.reducer;
